const convertISOToUTC = (time: string = '') => {
    let currentTime = new Date()
    if (time !== '') {
        const convertTime = new Date(time)
        const year = convertTime.getUTCFullYear()
        // Month
        const month = convertTime.getUTCMonth() + 1
        let monthStr = `${month}`
        if (month < 10) {
            monthStr = `0${month}`
        }
        // Day
        const day = convertTime.getUTCDate()
        let dayStr = `${day}`
        if (day < 10) {
            dayStr = `0${day}`
        }
        // Hours
        const hours = convertTime.getUTCHours()
        let hoursStr = `${hours}`
        if (hours < 10) {
            hoursStr = `0${hours}`
        }
        // Minutes
        const minutes = convertTime.getUTCMinutes()
        let minuteStr = `${minutes}`
        if (minutes < 10) {
            minuteStr = `0${minutes}`
        }
        // Seconds
        const seconds = convertTime.getUTCSeconds()
        let secondsStr = `${seconds}`
        if (seconds < 10) {
            secondsStr = `0${seconds}`
        }
        currentTime = new Date(`${year}-${monthStr}-${dayStr} ${hoursStr}:${minuteStr}:${secondsStr}`)
    }
    return currentTime
}

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

const nth = (d: number) => {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
        case 1:
            return 'st'
        case 2:
            return 'nd'
        case 3:
            return 'rd'
        default:
            return 'th'
    }
}

const convertDateTime = (time: any, type = 0) => {
    const date = new Date(time)
    const day = date.getDate()
    const dayName = days[date.getDay()]
    const month = date.getMonth() + 1
    const monthName = months[month]
    const year = date.getFullYear()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()

    const addZero = (date: number) => String(date).padStart(2, '0')

    switch (type) {
        case 0: {
            // 30/10/2022 07:30
            const formatDate = addZero(day) + '/' + addZero(month) + '/' + year
            const formatTime = addZero(hours) + ':' + addZero(minutes)
            return `${formatDate} ${formatTime}`
        }
        case 1: {
            // Friday, 15 Oct 2022
            return `${dayName}, ${day} ${monthName} ${year}`
        }
        case 2: {
            // Oct 5th, 2022
            return `${monthName} ${day}${nth(day)}, ${year}`
        }
        case 3: {
            // 06:30
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
        }
        case 4: {
            // 15 Wed, 2022
            return `${day} ${monthName.slice(0, 3)}, ${year}`
        }
        case 5: {
            // Wed 15, 2022
            return `${monthName.slice(0, 3)} ${day}, ${year}`
        }
        case 6: {
            // 2022-10-18 11:04:20
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
        case 7: {
            // 30/10/2022
            const formatDate = addZero(day) + '/' + addZero(month) + '/' + year
            return formatDate
        }
        default:
            return ''
    }
}

type TFormatDate = 'YYYY-MM-DD HH:MM:SS'

const formatInvalidDate = (dateTime: string, format: TFormatDate) => {
    switch (format) {
        case 'YYYY-MM-DD HH:MM:SS':
            return dateTime.slice(0, 10)
        default:
            return ''
    }
}

const convertDateToISO = (dateString: string) => {
    // Regular expression to match the exact format YYYY-MM-DD HH:mm:ss
    const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

    if (regex.test(dateString)) {
        // Replace the space with 'T' to convert to ISO 8601 format
        return dateString.replace(' ', 'T')
    } else {
        return dateString
    }
}

const dateToString = (dateTime: number | string, format: string = 'DD/MM/YYYY') => {
    let date
    if (!dateTime) {
        date = new Date()
    } else {
        if (typeof dateTime === 'string') {
            const a = dateTime.split(/[^0-9]/)
            date = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]), Number(a[5]))
        } else {
            date = new Date(dateTime * 1000)
        }
    }

    const rawDay = date.getUTCDate()
    const rawMonth = date.getUTCMonth() + 1
    const day = rawDay < 10 ? `0${rawDay}` : rawDay
    const month = rawMonth < 10 ? `0${rawMonth}` : rawMonth
    const rawHours = date.getUTCHours()
    const rawMinutes = date.getUTCMinutes()
    const hours = rawHours >= 10 ? rawHours : `0${rawHours}`
    const minutes = rawMinutes >= 10 ? rawMinutes : `0${rawMinutes}`
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear()
        default:
            return (
                day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds()
            )
    }
}

export { formatInvalidDate, convertDateToISO, convertISOToUTC, convertDateTime, dateToString }
